import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { AboutComponent } from './pages/about/about.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ContactComponent } from './shared/contact/contact.component';
import {MatIconModule} from "@angular/material/icon";
import { ContactSwiperComponent } from './shared/contact-swiper/contact-swiper.component';
import { HomeComponent } from './pages/home/home.component';
import { SkillsComponent } from './pages/skills/skills.component';
import { CurriculumComponent } from './shared/curriculum/curriculum.component';
import { CurriculumSwiperComponent } from './shared/curriculum-swiper/curriculum-swiper.component';
import { HeaderComponent } from './shared/header/header.component';
import { DownArrowComponent } from './shared/down-arrow/down-arrow.component';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    AboutComponent,
    ContactComponent,
    ContactSwiperComponent,
    HomeComponent,
    SkillsComponent,
    CurriculumComponent,
    CurriculumSwiperComponent,
    HeaderComponent,
    DownArrowComponent
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatIconModule
    ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
